import React from 'react';
import { components } from 'react-select';

const statusOptions = [
	{ value: 'I', label: 'I' },
	{ value: 'E', label: 'E' },
	{ value: 'P', label: 'P' },
	{ value: 'R', label: 'R' },
	{ value: 'W', label: 'W' },
];

const Option = (props) => {
	return (
		<div>
			<components.Option {...props}>
				<input type="checkbox" checked={props.isSelected} onChange={() => null} /> <label>{props.label}</label>
			</components.Option>
		</div>
	);
};

export default Option;
export { statusOptions };
